import React from "react";

import { useIntl } from "react-intl";

import { CardCollapse, CollapsePanel } from "@mapmycustomers/ui";

import styles from "./InfoFiled.module.scss";

interface Props {}

const InfoField: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <CardCollapse defaultActiveKey={["1"]}>
        <CollapsePanel
          header={
            <div className={styles.title}>
              {intl.formatMessage({
                id: "settings.mergeDuplicates.previewMergePane.infoField.title",
                defaultMessage: "What happens when I merge records?",
                description:
                  "Settings Merge duplicates - description of preview/merge pane - info field - title",
              })}
            </div>
          }
          key="1"
        >
          <ul className={styles.list}>
            <li>
              {intl.formatMessage({
                id: "settings.mergeDuplicates.previewMergePane.infoField.point1",
                defaultMessage:
                  "If only one of the records have a value for a given field, that value will be included in the merged record.",
                description:
                  "Settings Merge duplicates - description of preview/merge pane - info field - point 1",
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: "settings.mergeDuplicates.previewMergePane.infoField.point2",
                defaultMessage:
                  "If both records have a value for a given field, the primary record will automatically take precedence.",
                description:
                  "Settings Merge duplicates - description of preview/merge pane - info field - point 2",
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: "settings.mergeDuplicates.previewMergePane.infoField.point3",
                defaultMessage:
                  "Record history of notes, activities and files will be merged together.",
                description:
                  "Settings Merge duplicates - description of preview/merge pane - info field - point 3",
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: "settings.mergeDuplicates.previewMergePane.infoField.point4",
                defaultMessage:
                  "Any groups, routes, territories or saved filters that either record belonged to will persist after merging.",
                description:
                  "Settings Merge duplicates - description of preview/merge pane - info field - point 4",
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: "settings.mergeDuplicates.previewMergePane.infoField.point5",
                defaultMessage:
                  "Upon merge, the secondary record will be deleted and the primary record will hold all merged data.",
                description:
                  "Settings Merge duplicates - description of preview/merge pane - info field - point 5",
              })}
            </li>
          </ul>
        </CollapsePanel>
      </CardCollapse>
    </div>
  );
};

export default InfoField;
